import {AbstractControl, ValidationErrors, Validators} from '@angular/forms';

export const commaSeparatedEmails = (
  control: AbstractControl,
): ValidationErrors | null => {
  if (control.value === '' || !control.value || validateEmails(control.value)) {
    return null;
  }

  return {emails: true};
};

function validateEmails(emails: string) {
  return (
    emails
      .split(',')
      .map(email => email.trim())
      .map(email => Validators.email(<AbstractControl>{value: email}))
      .find(emailError => emailError !== null) === undefined
  );
}
